import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdControlEntitiesSuspense } from "api/generated/users/users";

export function useControlEntitiesForUserQuery(userId: number) {
    return useGetUsersUserIdControlEntitiesSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
